import { callApi } from '../../../../../apiCaller';
import { API_SYSTEM_ADMIN_BUNDLED_SEATS, DEFAULT_FN } from '../../../../../constants';
import { toastError } from '../../../../../utils';

export const GET_SYSTEM_ADMIN_BUNDLED_SEATS = 'getSystemAdminBundledSeat';

export const fetchSystemAdminBundledSeat = (bundledSeats) => {
     return {
          type: GET_SYSTEM_ADMIN_BUNDLED_SEATS,
          payload: bundledSeats,
     };
};

export const fetchAdminBundledSeatRequest = (nextDispatch) => (dispatch) => {
     const { isLoading, setIsLoading, paginationPayload, setIsFirstLoading = DEFAULT_FN } = nextDispatch;
     const { page, pageSize, sortBy, sortType, filter } = paginationPayload;

     const filterQuery = Object.keys(filter).length ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '';

     const endPoint = `${API_SYSTEM_ADMIN_BUNDLED_SEATS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;

     !isLoading && setIsLoading(true);

     callApi(endPoint, 'GET').then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }
          setIsLoading(false);
          setIsFirstLoading(false);
          dispatch(fetchSystemAdminBundledSeat(response.data));
     });
};
